/** De pagina achter een lade vastzetten. `overflow: hidden` op body alleen is
    niet genoeg: op mobiel scrollt html, dus de pagina liep gewoon door. */
var bellascenaBewaardeScroll = 0;

function bellascenaZetVast() {
  if (document.body.style.position === 'fixed') return;
  bellascenaBewaardeScroll = window.scrollY || document.documentElement.scrollTop || 0;
  document.documentElement.style.overflow = 'hidden';
  document.body.style.position = 'fixed';
  document.body.style.top = '-' + bellascenaBewaardeScroll + 'px';
  document.body.style.left = '0';
  document.body.style.right = '0';
  document.body.style.overflow = 'hidden';
}

function bellascenaLaatLos() {
  document.documentElement.style.overflow = '';
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.left = '';
  document.body.style.right = '';
  document.body.style.overflow = '';
  window.scrollTo(0, bellascenaBewaardeScroll);
}

(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Sticky Header ── */
  function initSticky() {
    var section = document.querySelector('.bellascena-header-section');
    if (!section || section.dataset.sticky !== 'true') return;

    var header = document.getElementById('bellascena-header');
    var threshold = 100;
    var lastScroll = 0;
    var ticking = false;

    // Create spacer to prevent layout shift when header becomes fixed
    var spacer = document.createElement('div');
    spacer.className = 'bellascena-header__spacer';
    spacer.style.display = 'none';
    header.parentNode.insertBefore(spacer, header.nextSibling);

    function onScroll() {
      if (ticking) return;
      ticking = true;

      requestAnimationFrame(function () {
        var currentScroll = window.scrollY;

        if (currentScroll > threshold) {
          if (!section.classList.contains('is-sticky')) {
            section.classList.add('is-sticky');
            spacer.style.display = 'block';
            spacer.style.height = header.offsetHeight + 'px';
          }

          // Show on scroll up, hide on scroll down
          if (currentScroll < lastScroll) {
            section.classList.add('is-visible');
          } else {
            section.classList.remove('is-visible');
          }
        } else {
          section.classList.remove('is-sticky', 'is-visible');
          spacer.style.display = 'none';
        }

        lastScroll = currentScroll;
        ticking = false;
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ── Sliding Berry Underline ── */
  function initSlidingUnderline() {
    var track = document.querySelector('.bellascena-header__nav-track');
    if (!track) return;

    var indicator = track.querySelector('.bellascena-header__nav-indicator');
    var items = track.querySelectorAll('.bellascena-header__nav-item');
    var activeItem = track.querySelector('.bellascena-header__nav-item.is-active');

    function moveIndicator(el) {
      if (!el) {
        indicator.style.width = '0px';
        return;
      }
      var trackRect = track.getBoundingClientRect();
      var itemRect = el.getBoundingClientRect();
      indicator.style.width = itemRect.width + 'px';
      indicator.style.transform = 'translateX(' + (itemRect.left - trackRect.left) + 'px)';
    }

    // Initialize on active item
    if (activeItem) {
      moveIndicator(activeItem);
    }

    items.forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        moveIndicator(item);
      });
    });

    track.addEventListener('mouseleave', function () {
      moveIndicator(activeItem);
    });
  }

  /* ── Drawer ── */
  function initDrawer() {
    var drawer = document.getElementById('bellascena-drawer');
    if (!drawer) return;

    var panel = drawer.querySelector('.bellascena-drawer__panel');
    var openers = document.querySelectorAll('[data-drawer-toggle]');
    var closers = drawer.querySelectorAll('[data-drawer-close]');
    var previousFocus = null;

    function openDrawer() {
      previousFocus = document.activeElement;
      drawer.hidden = false;
      drawer.offsetHeight; // force reflow
      drawer.classList.add('is-open');
      bellascenaZetVast();

      var closeBtn = drawer.querySelector('[data-drawer-close]:not(.bellascena-drawer__scrim)');
      if (closeBtn) closeBtn.focus();
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      bellascenaLaatLos();

      if (reducedMotion) {
        drawer.hidden = true;
        if (previousFocus) previousFocus.focus();
      } else {
        drawer.addEventListener('transitionend', function onEnd() {
          drawer.hidden = true;
          drawer.removeEventListener('transitionend', onEnd);
          if (previousFocus) previousFocus.focus();
        }, { once: true });
      }
    }

    openers.forEach(function (btn) {
      btn.addEventListener('click', openDrawer);
    });

    closers.forEach(function (btn) {
      btn.addEventListener('click', closeDrawer);
    });

    // Focus trap + Escape
    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeDrawer();
        return;
      }

      if (e.key !== 'Tab') return;

      var focusable = panel.querySelectorAll('a[href], button:not([disabled])');
      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  }

  /* ── Search Overlay ── */
  function initSearch() {
    var search = document.getElementById('bellascena-search');
    if (!search) return;

    var input = search.querySelector('[data-search-input]');
    var resultsContainer = search.querySelector('[data-search-results]');
    var openers = document.querySelectorAll('[data-search-toggle]');
    var closers = search.querySelectorAll('[data-search-close]');
    var previousFocus = null;
    var debounceTimer = null;

    function openSearch() {
      previousFocus = document.activeElement;
      search.hidden = false;
      search.offsetHeight;
      search.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      if (input) input.focus();
    }

    function resetSearch() {
      if (input) input.value = '';
      if (resultsContainer) { resultsContainer.innerHTML = ''; resultsContainer.hidden = true; }
      search.removeAttribute('data-has-query');
      if (previousFocus) previousFocus.focus();
    }

    function closeSearch() {
      search.classList.remove('is-open');
      document.body.style.overflow = '';

      if (reducedMotion) {
        search.hidden = true;
        resetSearch();
      } else {
        search.addEventListener('transitionend', function onEnd() {
          search.hidden = true;
          search.removeEventListener('transitionend', onEnd);
          resetSearch();
        }, { once: true });
      }
    }

    openers.forEach(function (btn) {
      btn.addEventListener('click', openSearch);
    });

    closers.forEach(function (btn) {
      btn.addEventListener('click', closeSearch);
    });

    search.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeSearch();
    });

    // Predictive search
    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function renderResults(query, products) {
      var label = window.bcLabel || function () { return ''; };
      if (products.length === 0) {
        // The whole sentence is the translation; the query is the only token we fill.
        var emptyTitle = label('search_empty_title').replace('__query__', escapeHtml(query));
        return (
          '<div class="bellascena-search__empty">' +
          '<span class="bellascena-search__empty-mark" aria-hidden="true"></span>' +
          '<h3 class="bellascena-search__empty-title">' + emptyTitle + '</h3>' +
          '<p class="bellascena-search__empty-sub">' + escapeHtml(label('search_empty_sub')) + '</p>' +
          '</div>'
        );
      }

      var cards = products.map(function (p) {
        var img = p.image
          ? '<img src="' + p.image + '" class="bc-card__img" alt="' + escapeHtml(p.title) + '" loading="lazy">'
          : '';
        return (
          '<div class="bc-card">' +
          '<a href="' + p.url + '" class="bc-card__link">' +
          '<div class="bc-card__media">' + img + '</div>' +
          '<div class="bc-card__plaque">' +
          '<h3 class="bc-card__name">' + escapeHtml(p.title) + '</h3>' +
          '<span class="bc-card__price">' + p.price + '</span>' +
          '</div>' +
          '</a>' +
          '</div>'
        );
      }).join('');

      var searchUrl = window.Shopify.routes.root + 'search?q=' + encodeURIComponent(query) + '&type=product';
      // Zin en zoekterm zaten hier als twee stukken aan elkaar geplakt. Talen die
      // de zoekterm vooropzetten kregen daardoor een omgedraaide zin, dus de hele
      // regel is nu \u00E9\u00E9n vertaling met de term als enige invulling.
      var viewAll = label('search_view_all').replace(
        '__query__',
        '<em>\u201C' + escapeHtml(query) + '\u201D</em>'
      );
      return (
        '<span class="bellascena-search__results-label">' + escapeHtml(label('search_results_label')) + '</span>' +
        '<div class="bellascena-search__grid">' + cards + '</div>' +
        '<a href="' + searchUrl + '" class="bellascena-search__view-all">' + viewAll + '</a>'
      );
    }

    if (input && resultsContainer) {
      input.addEventListener('input', function () {
        clearTimeout(debounceTimer);
        var query = input.value.trim();

        if (query.length < 2) {
          resultsContainer.innerHTML = '';
          resultsContainer.hidden = true;
          search.removeAttribute('data-has-query');
          return;
        }

        search.setAttribute('data-has-query', '');
        resultsContainer.hidden = false;

        debounceTimer = setTimeout(function () {
          fetch(
            window.Shopify.routes.root +
              'search/suggest.json?q=' +
              encodeURIComponent(query) +
              '&resources[type]=product&resources[limit]=6'
          )
            .then(function (r) { return r.json(); })
            .then(function (data) {
              var products = data.resources.results.products || [];
              resultsContainer.innerHTML = renderResults(query, products);
            })
            .catch(function () {
              resultsContainer.innerHTML = '';
            });
        }, 250);
      });
    }
  }

  /* ── Bag Pulse ── */
  function initBagPulse() {
    document.addEventListener('cart:item-added', function () {
      var counters = document.querySelectorAll('.bellascena-header__bag-count');
      counters.forEach(function (counter) {
        counter.classList.remove('is-pulsing');
        counter.offsetHeight;
        counter.classList.add('is-pulsing');
      });
    });
  }

  /* ── Mega Menu ── */
  function initMegaMenu() {
    var mega = document.getElementById('bellascena-mega');
    if (!mega) return;

    var navItems = document.querySelectorAll('[data-mega-menu]');
    var panels = mega.querySelectorAll('[data-mega-panel]');
    var hideTimer = null;

    function showPanel(handle) {
      clearTimeout(hideTimer);
      panels.forEach(function (p) { p.hidden = true; });
      var target = mega.querySelector('[data-mega-panel="' + handle + '"]');
      if (target) {
        target.hidden = false;
        mega.classList.add('is-open');
        mega.hidden = false;
      }
    }

    function hideAll() {
      hideTimer = setTimeout(function () {
        mega.classList.remove('is-open');
        panels.forEach(function (p) { p.hidden = true; });
        mega.hidden = true;
      }, 150);
    }

    navItems.forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        showPanel(item.dataset.megaMenu);
      });
      item.addEventListener('mouseleave', function () {
        hideAll();
      });
    });

    mega.addEventListener('mouseenter', function () {
      clearTimeout(hideTimer);
    });

    mega.addEventListener('mouseleave', function () {
      hideAll();
    });

    navItems.forEach(function (item) {
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          showPanel(item.dataset.megaMenu);
        }
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mega.classList.contains('is-open')) {
        clearTimeout(hideTimer);
        mega.classList.remove('is-open');
        panels.forEach(function (p) { p.hidden = true; });
        mega.hidden = true;
      }
    });
  }

  /* ── Drawer Drill-Down ── */
  function initDrawerDrillDown() {
    var drawer = document.getElementById('bellascena-drawer');
    if (!drawer) return;

    var mainView = drawer.querySelector('[data-drawer-view="main"]');
    var subButtons = drawer.querySelectorAll('[data-drawer-submenu]');
    var backButtons = drawer.querySelectorAll('[data-drawer-back]');

    function showSub(index) {
      var subView = drawer.querySelector('[data-drawer-view="sub-' + index + '"]');
      if (!subView || !mainView) return;
      mainView.hidden = true;
      subView.hidden = false;
      var firstLink = subView.querySelector('a, button');
      if (firstLink) firstLink.focus();
    }

    function showMain() {
      var openSub = drawer.querySelector('.bellascena-drawer__view--sub:not([hidden])');
      if (openSub) openSub.hidden = true;
      if (mainView) mainView.hidden = false;
    }

    subButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        showSub(btn.dataset.drawerSubmenu);
      });
    });

    backButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        showMain();
      });
    });

    var closeButtons = drawer.querySelectorAll('[data-drawer-close]');
    closeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setTimeout(showMain, 400);
      });
    });
  }

  /* ── Init All ── */
  document.addEventListener('DOMContentLoaded', function () {
    initSticky();
    initSlidingUnderline();
    initDrawer();
    initSearch();
    initBagPulse();
    initMegaMenu();
    initDrawerDrillDown();
  });
})();
